import request from "./httpService";
const VALIDLOCATIONSERVICES_API_ENDPOINT = '/admin/validlocation';


/////////////////////////////////////////////////////////////////////
//  Province 
/////////////////////////////////////////////////////////////////////
const getProvinces = (countryId) => {
    return request({
        method: "GET",
        url: `${VALIDLOCATIONSERVICES_API_ENDPOINT}/province/${countryId}`,
    });
};

const getCities = (countryId) => {
    return request({
        method: "GET",
        url: `${VALIDLOCATIONSERVICES_API_ENDPOINT}/city/${countryId}`,
    });
};

export const validLocationService = {
    getProvinces,
    getCities
}